import dayjs, { Dayjs } from 'dayjs'
import { RoomUniqueId } from 'src/models/Room/types'

const SCHEDULED_TIME_FORMAT = 'MM/DD HH:mm'
export const formatScheduledTime = (date: Date | Dayjs) =>
  dayjs(date).format(SCHEDULED_TIME_FORMAT)

const roomIdFormat = /^[rg]-[0-9]+$/
export const isRoomIdFormat = (id: RoomUniqueId) => roomIdFormat.test(id)
